import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges
} from '@angular/core';
import {
	QuestionnaireTemplate,
	TemplatePreviews
} from '@web-components/settings/settings.model';
import { PageRequest } from '@models/models';
import { PaginationService } from '@services/pagination/pagination.service';

@Component({
	selector: 'questionnaire-template-list',
	template: require('./questionnaire-template-list.html'),
	styles: [require('./questionnaire-template-list.scss')]
})
export class QuestionnaireTemplateListComponent implements OnInit, OnChanges {
	@Input() templates: TemplatePreviews;
	@Input() btnDisable: boolean;
	@Input() pageRequest: PageRequest;
	@Output() onEdit: EventEmitter<QuestionnaireTemplate> = new EventEmitter();
	@Output()
	onDuplicate: EventEmitter<QuestionnaireTemplate> = new EventEmitter();
	@Output() onDelete: EventEmitter<QuestionnaireTemplate> = new EventEmitter();
	@Output()
	updatePaginationParams: EventEmitter<PageRequest> = new EventEmitter();

	pageNumbers: Array<number> = [];
	totalItems: number;
	currentActiveId: string | number;

	constructor(private paginationService: PaginationService) {}

	ngOnInit(): void {
		this.updatePageRequestParams();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			changes.templates &&
			!changes.templates.isFirstChange() &&
			changes.templates.currentValue.items.length
		) {
			this.updatePageRequestParams();
		}
	}

	updateTemplate(data): void {
		this.updatePaginationParams.emit(data);
	}

	edit(template: QuestionnaireTemplate): void {
		this.onEdit.emit(template);
	}

	duplicate(template: QuestionnaireTemplate): void {
		this.currentActiveId = template.id;
		this.onDuplicate.emit(template);
	}

	deleteItem(template: QuestionnaireTemplate): void {
		this.onDelete.emit(template);
	}

	orderByField(field: string): void {
		this.pageRequest.sortCriterias[0].fieldName = field;
		this.pageRequest.sortCriterias[0].sortAscending = !this.pageRequest
			.sortCriterias[0].sortAscending;
		this.updateTemplate(this.pageRequest);
	}

	private updatePageRequestParams(): void {
		this.totalItems = this.templates.totalSize;
		this.pageNumbers = this.paginationService.calculatePageNumbers(
			this.totalItems,
			this.pageRequest.paging.pageSize
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/common/questionnaire-template-list/questionnaire-template-list.ts